
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-information/[[...slug]]",
      function () {
        return require("private-next-pages/delivery-information/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-information/[[...slug]]"])
      });
    }
  